import { createSlice } from "@reduxjs/toolkit";
import { influencerSlice } from "types/influencer";
import { fetchBasicPostThunk, fetchBasicSocialPostThunk, fetchInfluencerInsights, fetchInfluencerSocialAccount, fetchMedia, fetchPost, fetchSocialPostsThunk, fetchSocialPostThunk } from "./thunk";
import { ERROR } from "types";

const initialState: influencerSlice = {
    loading: false,
    error: null,
    insights: {},
    postLoading: false,
    postError: null,
    mediaLoading: false,
    mediaError: null,
    posts: {},
    basic_posts: {},
    media: {},
    social_accounts: {},
    social_posts: {},
    social_media: {},
    basic_social_posts: {}
}

const influcencerSlice = createSlice({
    name: 'influencers',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchInfluencerInsights.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchInfluencerInsights.fulfilled, (state, {payload}) => {
            state.loading = false;
            state.error = null;

            const {influencerId, insightsData} = payload;

            state.insights[influencerId] =  {
                ...insightsData,
                last_fetched_at: Date.now()
            }
        })
        .addCase(fetchInfluencerInsights.rejected, (state, {payload}) => {
            state.loading = false;
            state.error = payload || "Failed to fetch influencer insights"
        })
        .addCase(fetchPost.pending, (state) => {
            state.postLoading = true;
            state.postError = null;
        })
        .addCase(fetchPost.fulfilled, (state, {payload}) => {
            state.postLoading = false;
            state.postError = null;

            const {influencerId, post, postId} = payload;

            const existingPosts = state.posts[influencerId] ?? {};

            state.posts[influencerId] = {
                ...existingPosts,
                [postId]: {
                    post,
                    last_fetched_at: Date.now()
                }
            }
            
        })
        .addCase(fetchPost.rejected, (state, {payload}) => {
            state.postLoading = false;
            state.postError = payload || "Failed to fetch post"
        })
        .addCase(fetchSocialPostThunk.pending, (state) => {
            state.postLoading = true;
            state.postError = null;
        })
        .addCase(fetchSocialPostThunk.fulfilled, (state, {payload}) => {
            state.postLoading = false;
            state.postError = null;

            const {socialAccountId, post, postId} = payload;

            const existingPosts = state.social_posts[socialAccountId] ?? {};

            state.social_posts[socialAccountId] = {
                ...existingPosts,
                [postId]: {
                    post,
                    last_fetched_at: Date.now()
                }
            }
            
        })
        .addCase(fetchSocialPostThunk.rejected, (state, {payload}) => {
            state.postLoading = false;
            state.postError = payload || "Failed to fetch post"
        })


        .addCase(fetchMedia.pending, (state) => {
            state.mediaLoading = true;
            state.mediaError = null;
        })
        .addCase(fetchMedia.fulfilled, (state, {payload}) => {
            state.mediaLoading = false;
            state.mediaError = null;

            const {influencerId, posts, mediaProductType, page} = payload;

            const existingMedia = state.media[influencerId] ?? {};

            const existingList = existingMedia[mediaProductType]?.items ?? [];

            const finalList = page === 1 ? posts.items : [...existingList, ...posts.items];

            state.media[influencerId] = {
                ...existingMedia,
                [mediaProductType]: {
                    items: finalList,
                    count: posts.count,
                    has_more: posts.count > finalList.length,
                    last_fetched_at: Date.now(),
                    expired: false,
                    page
                }
            }
        })
        .addCase(fetchMedia.rejected, (state, {payload}) => {
            state.mediaLoading = false;
            if(payload !== ERROR.CACHED)
                state.mediaError = payload || "Failed to fetch media"
        })
        .addCase(fetchSocialPostsThunk.pending, (state) => {
            state.mediaLoading = true;
            state.mediaError = null;
        })
        .addCase(fetchSocialPostsThunk.fulfilled, (state, {payload}) => {
            state.mediaLoading = false;
            state.mediaError = null;

            const {socialAccountId, posts, type, page} = payload;

            const existingMedia = state.social_media[socialAccountId] ?? {};

            const existingList = existingMedia[type]?.items ?? [];

            const finalList = page === 1 ? posts.items : [...existingList, ...posts.items];

            state.social_media[socialAccountId] = {
                ...existingMedia,
                [type]: {
                    items: finalList,
                    count: posts.count,
                    has_more: posts.count > finalList.length,
                    last_fetched_at: Date.now(),
                    expired: false,
                    page
                }
            }
        })
        .addCase(fetchSocialPostsThunk.rejected, (state, {payload}) => {
            state.mediaLoading = false;
            if(payload !== ERROR.CACHED)
                state.mediaError = payload || "Failed to fetch media"
        })
         .addCase(fetchBasicPostThunk.fulfilled, (state, {payload}) => {
            state.postLoading = false;
            state.postError = null;

            const {post, postId} = payload;


            state.basic_posts[postId] = {
                post,
                last_fetched_at: Date.now()
            }
            
        })
        .addCase(fetchInfluencerSocialAccount.fulfilled, (state, {payload}) => {
            const {socialAccount, socialAccountId} = payload;
            state.social_accounts[socialAccountId] = {
                social_account: socialAccount,
                last_fetched_at: Date.now()
            }
        })
        .addCase(fetchBasicSocialPostThunk.fulfilled, (state, {payload}) => {
            state.postLoading = false;
            state.postError = null;

            const {post, postId} = payload;


            state.basic_social_posts[postId] = {
                post,
                last_fetched_at: Date.now()
            }
            
        })
    }
})

export default influcencerSlice.reducer;